// Default vitamin slot configuration, ported verbatim from the original app.
export const VITS_DEFAULT = {
  slots: [
    {name:'Утро', time:'10:00', items:[
      {name:'Витамин D3',desc:'2000 МЕ'},
      {name:'Омега-3',desc:'1г'},
      {name:'Магний',desc:'300мг'},
    ]},
    {name:'Вечер', time:'20:00', items:[
      {name:'Витамин C',desc:'500мг'},
    ]}
  ]
};
